import React from 'react';
import PropTypes from 'prop-types';

class Legend extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'Legend';
    this.state = {
      inches: false,
      show : true
    }
  }

  render() {
    return (
    	<div className="map-legend">
        {(()=>{
          if(this.state.show) {
            return (
              <span
                onClick={() => {this.setState({show : false})}}
                className="legend-control"
                >Hide Legend
              </span>
            )
          }
          else {
            return (
              <span
                onClick={() => {this.setState({show : true})}}
                className="legend-control show">
                Show Legend
              </span>
            )
          }
        })()}
        {(()=>{
          if(this.state.show) {
            return (
              <div>
                <span className="legend-item"><span className="legend-level legend-level-1"> </span>{!this.state.inches? 'Quarter - Half Dollar' : '1.00”-1.25”'}</span>
                <span className="legend-item"><span className="legend-level legend-level-2"> </span>{!this.state.inches? 'Ping pong - Golf Ball' : '1.50”-1.75”'}</span>
                <span className="legend-item"><span className="legend-level legend-level-3"> </span>{!this.state.inches? 'Golf Ball - Tennis Ball' : '1.75”-2.50”'}</span>
                <span className="legend-item"><span className="legend-level legend-level-4"> </span>{!this.state.inches? 'Tennis Ball +' : '2.50”+'}</span>
                {this.state.inches && (
                  <div style={{ textAlign: 'center', background:'rgba(0,0,0,0.9)', cursor: 'pointer', marginLeft: -5, marginRight: -5 }} onClick={e => this.setState({ inches: false })}>Size Range</div>
                ) || (
                  <div style={{ textAlign: 'center', background:'rgba(0,0,0,0.9)', cursor: 'pointer', marginLeft: -5, marginRight: -5 }} onClick={e => this.setState({ inches: true })}>Inches Range</div>
                )}
              </div>
            )
          }
        })()}

  		</div>
    );
  }
}

export default Legend;



// WEBPACK FOOTER //
// ./src/browser/components/maps/legend.js